function IconEmail(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.25 0V10H0.75V0H13.25ZM12 1.81188L7 6.81218L2 1.8125V8.75H12V1.81188ZM10.7937 1.25H3.20562L7 5.04442L10.7937 1.25Z"
        fill="#1D2124"
      />
    </svg>
  );
}

function IconEvents(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 0.75H10.75V2H13.25V13.25H0.75V2H3.25V0.75H4.5V2H9.5V0.75ZM12 5.75H2V12H12V5.75ZM7.625 9.5V10.75H6.375V9.5H7.625ZM4.5 9.5V10.75H3.25V9.5H4.5ZM10.75 7V8.25H9.5V7H10.75ZM7.625 7V8.25H6.375V7H7.625ZM4.5 7V8.25H3.25V7H4.5ZM12 3.25H2V4.5H12V3.25Z"
        fill="#1D2124"
      />
    </svg>
  );
}

function IconHome(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.805481L0.375 5.74866V13.2487H4.75V10.1237H7.25V13.2487H11.625V5.74866L6 0.805481ZM6 2.46956L10.375 6.31426V11.9987H8.5V8.87366H3.5V11.9987H1.625V6.31426L6 2.46956Z"
        fill="#1D2124"
      />
    </svg>
  );
}

function IconLocationPin(
  props: React.SVGProps<SVGSVGElement>
): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.25C8.89949 0.25 11.25 2.60051 11.25 5.5C11.25 7.40363 9.67685 10.0255 6.5582 13.5009L6 14.123L5.4418 13.5009C2.32315 10.0255 0.75 7.40363 0.75 5.5C0.75 2.60051 3.10051 0.25 6 0.25ZM6 1.75C3.92893 1.75 2.25 3.42893 2.25 5.5C2.25 6.81584 3.49251 8.97463 6 11.8665C8.50749 8.97463 9.75 6.81584 9.75 5.5C9.75 3.42893 8.07107 1.75 6 1.75ZM6 3.25C7.24264 3.25 8.25 4.25736 8.25 5.5C8.25 6.74264 7.24264 7.75 6 7.75C4.75736 7.75 3.75 6.74264 3.75 5.5C3.75 4.25736 4.75736 3.25 6 3.25ZM6 4.75C5.58579 4.75 5.25 5.08579 5.25 5.5C5.25 5.91421 5.58579 6.25 6 6.25C6.41421 6.25 6.75 5.91421 6.75 5.5C6.75 5.08579 6.41421 4.75 6 4.75Z"
        fill="#1D2124"
      />
    </svg>
  );
}

function IconPhone(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.91773 2.67211L2.6855 0.904347C2.92958 0.660269 3.3253 0.660268 3.56938 0.904346L6.22103 3.556C6.46511 3.80007 6.46511 4.1958 6.22103 4.43988L5.33715 5.32376C5.39153 5.37814 5.84706 5.83368 6.70376 6.69037C7.56045 7.54707 7.9888 7.97541 7.9888 7.97541L8.87268 7.09153C9.11676 6.84745 9.51249 6.84745 9.75657 7.09153L12.4082 9.74318C12.6523 9.98726 12.6523 10.383 12.4082 10.6271L10.6404 12.3948C9.66414 13.3711 8.08123 13.3711 7.10491 12.3948C6.07372 11.3636 5.04252 10.3324 4.01132 9.30124C2.98013 8.27004 1.94893 7.23884 0.91773 6.20765C-0.0585804 5.23134 -0.0585804 3.64842 0.91773 2.67211ZM1.80161 3.556C1.31346 4.04415 1.31346 4.83561 1.80161 5.32376L7.9888 11.5109C8.47695 11.9991 9.26841 11.9991 9.75657 11.5109L11.0824 10.1851L9.31462 8.41736L7.9888 9.74318L3.56938 5.32376L4.89521 3.99794L3.12744 2.23017L1.80161 3.556Z"
        fill="#1D2124"
      />
    </svg>
  );
}

export const icons = {
  IconEmail,
  IconEvents,
  IconHome,
  IconLocationPin,
  IconPhone,
};
